import React from 'react';
import hyperjumpLogo from '../../images/hyperjump-white-colored.png';

const PageFooter = () => {
  const currentYear = new Date().getFullYear();

  return (
    <div className="bg-black mt-10 pt-8 pb-6 text-center text-gray-300 text-sm">
      <div className="max-w-5xl mx-auto px-6">
        <div className="font-bai font-semibold text-white mb-2">
          Sinar Mas Digital Day {currentYear}
        </div>
        <div className="text-gray-400">
          <div>© {currentYear} Sinar Mas Group. All Rights Reserved.</div>
          <div className="mt-2">
            Supported by{' '}
            <a
              href="https://hyperjump.tech"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img
                src={hyperjumpLogo}
                alt="Hyperjump Logo"
                className="inline-block h-4 ml-1"
              />
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PageFooter;
